<template>
    <div class="input-group">
        <select class="form-control" v-model="month" :required="required" @input="change" @change="change">
            <option value="">- Select Month -</option>
            <option v-for="m in months" :key="m.number" :value="m.number">{{ m.name }}</option>
        </select>
        <select class="form-control" v-model="year" :required="required" @input="change" @change="change">
            <option value="">- Select Year -</option>
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
        </select>
    </div>
</template>
<script>
    import { DateTime } from 'luxon';

    export default {
        props: ['modelValue', 'options', 'required'],
        emits: ['update:model-value'],
        data: function () {
            return {
                month: '',
                year: '',
                months: [],
                years: []
            }
        },
        watch: {
            modelValue(value) {
                let parts = (value || '').split('/');
                if (parts.length === 2) {
                    this.month = parts[0];
                    this.year = parts[1];
                }
                this.$emit('update:model-value', value);
            }
        },
        methods: {
            change() {
                if (this.month && this.year) {
                    this.$emit('update:model-value', this.month + '/' + this.year);
                }
            }
        },
        created() {
            let y = DateTime.local().year;
            while (this.years.length < 20)
                this.years.push((y++) + '');
            let m = DateTime.fromISO(`${y}-01-01`);
            while (this.months.length < 12) {
                let number = m.month + '';
                let name = m.toFormat('MMMM');
                this.months.push({ number, name });
                m = m.set({ month: (1 * number) + 1 });
            }
        }
    }
</script>